/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconColumnRemove = createReactComponent("outline", "column-remove", "IconColumnRemove", [["path", { "d": "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M16 10l4 4", "key": "svg-1" }], ["path", { "d": "M16 14l4 -4", "key": "svg-2" }]]);

export { IconColumnRemove as default };
//# sourceMappingURL=IconColumnRemove.mjs.map
